<template>
    <div>
        <v-row justify="space-between">
            <v-col
                v-if="label"
                class="text-left px-5"
            >
                <span
                    class="font-weight-bold black--text legend"
                    v-text="label"
                />
            </v-col>
            <v-col
                v-if="sublabel"
                class="text-right"
            >
                <span
                    class="font-weight-bold black--text legend"
                    v-text="sublabel"
                />
            </v-col>
        </v-row>
        <v-slider
            v-model="currentValue"
            :min="min"
            :max="max"
            :step="step"
            color="green darken-2"
            hide-details
        />
    </div>
</template>

<script>
    export default {
        name: 'StepSlider',
        props: {
            label: {
                type: String,
                required: true
            },
            sublabel: {
                type: String
            },
            min: {
                type: Number,
                required: true
            },
            max: {
                type: Number,
                required: true
            },
            step: {
                type: Number,
                required: true
            },
            defaultValue: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                currentValue: null
            }
        },
        mounted() {
            this.currentValue = this.defaultValue;
        },
        watch: {
            currentValue(newVal, oldVal) {
                if(oldVal)
                    this.$emit('update-slider', newVal);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/StepSlider.vue